import React, { useEffect, useState } from "react";
import { AreasSelector } from "@rankmi/rankmi-table";
import { areaslocale } from "../../../src/utilities/filter_config";
import { EnterpriseAreaService } from "../../../src/core/services/enterprise_area_service";
import tableUtilities from "../../../src/utilities/table_utilities";
import {
  getCurrentUser,
  getValueFromJwt,
} from "@frontend/src/utilities/jwtHelper";

const AreaFilter = ({ onChangeArea }) => {
  const [selectedArea, setSelectedArea] = useState(undefined);
  const [areas, setAreas] = useState([]);

  const enterPriseAreaService = new EnterpriseAreaService();

  const isAdmin =
    getValueFromJwt("is_superadmin") || getValueFromJwt("is_admin");

  useEffect(() => {
    getAreas();
  }, []);

  const getAreas = () => {
    enterPriseAreaService.getAll(
      (data) => {
        const areasMapped = data
          .map((area) => {
            return {
              id: area.id,
              name: area.name,
              parentId: area.parent_enterprise_area_id,
              token: area.token,
            };
          })
          .sort(tableUtilities.sortAreas);
        setAreas(areasMapped);
      },
      (err) => console.error(err)
    );
  };

  return (
    <div className="AreaFilter">
      <AreasSelector
        areas={areas}
        selectedArea={selectedArea}
        loading={false}
        onAreaSelected={(area) => {
          setSelectedArea(area);
          onChangeArea(area);
        }}
        mandatoryArea={isAdmin ? false : true}
        locale={areaslocale}
        style={{ width: "26%" }}
      />
    </div>
  );
};

export default AreaFilter;
